export default "__VITE_ASSET__DcSpq$tC__"